import React from 'react';
import PinPolaroid from './PinPolaroid';
import PetPhoto from './PetPhoto';
import type { Pet } from '../types';
import '../styles/PetFeature.css';

interface PetFeatureProps {
  pet: Pet;
  flip?: boolean;
  onOpen?: React.MouseEventHandler<HTMLAnchorElement>;
}

const PetFeature: React.FC<PetFeatureProps> = ({ pet, flip = false, onOpen }) => (
  <article className={`feat ${flip ? 'feat--flip' : ''}`}>
    <div className="feat__portrait-wrap">
      <PinPolaroid
        variant="feature"
        flip={flip}
        badge={pet.badge}
        caption={pet.name}
        tapeColor={pet.tapeColor || 'terracotta'}
        media={<PetPhoto pet={pet} />}
      />
    </div>
    <div className="feat__details">
      <div className="feat__ref">Ficha · {pet.ref} · {pet.tag}</div>
      <h3 className="feat__name">{pet.name}</h3>
      <div className="feat__line">{pet.line}</div>
      <p className="feat__copy">{pet.description}</p>
      {pet.traits.length > 0 && (
        <div className="feat__traits">
          {pet.traits.map((t) => (
            <span key={t}>{t}</span>
          ))}
        </div>
      )}
      <a
        className="feat__cta"
        href={pet.slug ? `/adotar/${pet.slug}` : '#'}
        onClick={onOpen}
      >
        {flip ? `← conhecer a ${pet.name}` : `conhecer o ${pet.name} →`}
      </a>
    </div>
  </article>
);

export default PetFeature;
